import React, { useEffect } from 'react';
import ORBNavBar from '../../../components/common/ORBNavBar';
import ORBApi from '../../../services/ORBApi';
import UsersTable from './components/UsersTable';
import Pagination from '@mui/material/Pagination';
import PlusIcon from '../../../icons/PlusIcon';
import FilterIcon from '../../../icons/FilterIcon';
import { Modal } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import NewUserPanel from './components/NewUserPanel';
import EditUserPanel from './components/EditUserPanel';
import { toast } from 'react-toastify';
import Loading from '../../../components/common/Loading';
import DebouncedTextField from '../../../components/common/DebouncedTextField';
import config from '../../../config';

const Users = () => {

    const [userList, setUserList] = React.useState({current_page:1, pages:1, users:[]});
    const [searchFilter, setSearchFilter] = React.useState("");
    const [order, setOrder] = React.useState('desc');
    const [orderBy, setOrderBy] = React.useState('id');
    const [showCreateUserPanel, setShowCreateUserPanel] = React.useState(false);
    const [showFilters, setShowFilters] = React.useState(false);
    const [userToEdit, setUserToEdit] = React.useState(null);
    const [isLoading, setIsLoading] = React.useState(false);

    useEffect(() => {
        listUsers(1);
    }, []);

    const listUsers = (page, search_filter) => {
        setIsLoading(true);
        setSearchFilter(search_filter);
        ORBApi.listUsers(page, search_filter, config.default_page_size, orderBy, order)
        .then((data) => {
           setUserList(data); 
        })
        .catch((ex) => {
            toast.error("Falha ao carregar usuários.")
        })
        .finally(() => {
            setIsLoading(false);
        })
    }

    const onSortChangeHandler = (newOrderBy, newOrder) => {
        setOrderBy(newOrderBy);
        setOrder(newOrder);
        // Recarrega a primeira página quando a ordenação muda
        listUsers(1, searchFilter);
    }
    const onCreateUserHandler = (user) => {
        setShowCreateUserPanel(false);
        if (user && user.email) {
            toast.success(`Usuário ${user.email} criado com sucesso!`);
        } else if (user && user.name) {
            toast.success(`Usuário ${user.name} criado com sucesso!`);
        } else {
            toast.success('Usuário criado com sucesso!');
        }
        listUsers(userList.current_page, searchFilter)
    }
    const onEditUserHandler = (user) => {
        setUserToEdit(user);
    }
    const onUpdateUserHandler = () => {
        setUserToEdit(null);
        listUsers(userList.current_page, searchFilter);
    }
    const onDeleteUserHandler = (id) => {
        if (!id) {
            toast.error("ID do usuário não encontrado.");
            return;
        }

        setIsLoading(true);
        ORBApi.deleteUser(id).then(() => {
            toast.success("Usuário desabilitado com sucesso!");
            listUsers(userList.current_page, searchFilter);
        }).catch((ex) => {
            // Tenta extrair mensagem de erro mais específica
            let errorMessage = "Falha ao desabilitar usuário.";
            if (ex?.response?.data) {
                errorMessage = ex.response.data.message || 
                             ex.response.data.error || 
                             ex.response.data.detail ||
                             errorMessage;
            } else if (ex?.message) {
                errorMessage = ex.message;
            }
            
            // Se for erro 500, geralmente é o auth-service recusando o DELETE do app
            // (app id configurado em [app].id não existe / não pertence ao partner).
            if (ex?.response?.status === 500) {
                errorMessage = "Erro ao desabilitar no serviço de contas (auth). Verifique se [app].id da config do royalties corresponde a uma aplicação válida do partner no auth-service.";
            }
            
            toast.error(errorMessage);
        }).finally(() => {
            setIsLoading(false);
        })
    }
    return (
        <div id="users-page">
            {/*Website navigation Bar  */}
            <ORBNavBar page_title="Admin > Users" selectedOption="drop_admin" />
            
            {/* Page action bar */}
            <div className="page-actionbar-container">
                <div className="page-actionbar-item action-btn" onClick={()=>{setShowFilters(!showFilters)}}>
                    <FilterIcon />
                </div>
                <div className="page-actionbar-item action-btn" onClick={()=>{setShowCreateUserPanel(!showCreateUserPanel);}}>
                    <PlusIcon />
                </div>
            </div>
            {showFilters ? 
            <div className='page-filter-bar'>
                <DebouncedTextField label="Buscar por ..." onChange={((filter) => { listUsers(userList.current_page, filter)})} />
            </div>
            : null
            }

            {isLoading ?
            <Loading text="Carregando usuários" /> :
            <UsersTable
                data={userList.users}
                onDelete={onDeleteUserHandler}
                onEdit={onEditUserHandler}
                onSortChange={onSortChangeHandler}
                order={order}
                orderBy={orderBy}
            />
            }
            <Pagination className='table-pagination' shape='rounded'
                count={userList.pages} page={userList.current_page} onChange={(e, value) => { listUsers(value, searchFilter);}} />
            {/* Modal panel for user creating */}
            <Modal open={showCreateUserPanel} onClose={()=> {setShowCreateUserPanel(false);}}
                    slots={{ backdrop: Backdrop }} slotProps={{ backdrop: { timeout: 500 } }}>
                <div className="modal-container" style={{overflow: 'auto'}}>
                    <NewUserPanel onCreate={onCreateUserHandler}/>
                </div>

            </Modal>
            {/* Modal panel for user editing */}
            <Modal open={!!userToEdit} onClose={()=> {setUserToEdit(null);}}
                    slots={{ backdrop: Backdrop }} slotProps={{ backdrop: { timeout: 500 } }}>
                <div className="modal-container" style={{overflow: 'auto'}}>
                    {userToEdit ? <EditUserPanel user={userToEdit} onUpdate={onUpdateUserHandler}/> : <div/>}
                </div>

            </Modal>

        </div>
    )
}

export default Users;